export default class SpecialtyModel {
  constructor(data) {
    if (!data) {
      data = {};
    }
    this.academic_distress = data.academic_distress || 0;
    this.depression = data.depression || 0;
    this.eating_disorders = data.eating_disorders || 0;
    this.family_distress = data.family_distress || 0;
    this.general_anxiety = data.general_anxiety || 0;
    this.relationship_issues = data.relationship_issues || 0;
    this.sexual_assault = data.sexual_assault || 0;
    this.sexuality = data.sexuality || 0;
    this.social_anxiety = data.social_anxiety || 0;
    this.stress = data.stress || 0;
    this.substance_abuse = data.substance_abuse || 0;
    this.trauma_ptsd = data.trauma_ptsd || 0;
  }
}
